// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1716":"d6955da2","4865":"d6955da2"}[chunkId] + ".chunk.css";
};